export default __webpack_public_path__ + "static/media/image-5.27d3aafa.webp";